"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.artifactType = exports.NodeTypeSchema = exports.NodeConfigSchema = void 0;
const zod_1 = require("zod");
const finley_types_1 = require("@finley-technologies/finley-types");
const types_1 = require("../../uiNodes/tapes/intermediate-tape/types");
Object.defineProperty(exports, "artifactType", { enumerable: true, get: function () { return types_1.artifactType; } });
const tasks_1 = require("../../uiNodes/tasks");
exports.NodeConfigSchema = tasks_1.TapeBuilderTaskSchema;
exports.NodeTypeSchema = finley_types_1.DbTable.ArtifactWithSlugsSchema.extend({
    externalFilename: zod_1.z.null(),
    type: zod_1.z.literal('intermediateTape'),
    configuration: exports.NodeConfigSchema,
});
//# sourceMappingURL=node.js.map